import { MapEffects } from '../map/map.effects';
import { UserApiEffects } from '../user/user.effects';
import { GraphApiEffects } from '../graph/graph.effect';
import { ProxyGroupEffects } from '../proxy-group/proxy-group-effects';
import { AdminTemplateEffects } from '../admin/admin.effect';
import { SiteRequestEffects } from '../site-request/site-request.effects';
import { TravelRequestEffects } from 'src/app/feature/pre-trip/store/travel-request.effects';

export const Effects = [MapEffects, UserApiEffects, GraphApiEffects, ProxyGroupEffects, AdminTemplateEffects, SiteRequestEffects, TravelRequestEffects];
